import React from 'react';
import img from "../../assets/images/print.svg";
import styled from 'styled-components';





const PrintBtn = ({ onClick, label = "Print" }) => {

    const print = () => {

        onClick ? onClick() : window.print()
    }

    return (
        <PrintBtmWrapper className='noPrint' type="button" onClick={print} >
            <img src={img} alt="Print"/>
            {label}
        </PrintBtmWrapper>
    )
};





export default PrintBtn;


const PrintBtmWrapper = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  img {
    width: 20px;
    height: 20px;
  }
`;